<template>
  <div class="whole">
    <div class="breadcrumbs flex ai">
      <div @click="router.push('/')" class="breadcrumbs-txt pointer">主页</div>
      <img class="iconArrow" src="@/assets/iconArrow.png" alt="" />
      <div class="breadcrumbs-txt1 default">畅销明星 Best-Selling Star</div>
    </div>
    <div class="main-content flex column jcs">
      <div>
        <div class="bannerBox flex jcc">
          <div style="width: 1371px">
            <img class="ScienceThatMatters" src="@/assets/bestSellingStar/Best-sellingStar.png" alt="" />
          </div>
        </div>
        <div class="flex jcc">
          <div class="product-box flex jcs">
            <img @click="toProduct('成人心脏&肝脏辅酶Q10/水飞蓟/复合维生素')" class="product"
              src="@/assets/bestSellingStar/product1.png" alt="" />
            <img @click="toProduct('成人高纯鱼油')" class="product" src="@/assets/bestSellingStar/product2.png" alt="" />
            <img @click="toProduct('成人高纯鱼油')" class="product" src="@/assets/bestSellingStar/product4.jpg" alt="" />
            <img @click="toProduct('成人高纯鱼油')" class="product" src="@/assets/bestSellingStar/product5.jpg" alt="" />
            <img @click="toProduct('成人高纯鱼油')" class="product" src="@/assets/bestSellingStar/product6.jpg" alt="" />
            <img @click="toProduct('真果肉复合维生素（专为女性设计）')" class="product" src="@/assets/bestSellingStar/product3.png"
              alt="" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script setup>
import Footer from "../../components/Footer.vue";
import { useRouter } from "vue-router";
const router = useRouter();
const toProduct = (name) => {
  return;
  router.push({ name: "ProductDetails", query: { name: name } });
};
</script>

<style src="./bestSellingStar.css" scoped></style>
